<template>
    <div class="ha-multiplier-events ">
      This is the multiplier events page
    </div>
  </template>
  
  <script>
    export default {
        name: "MultiplierEvents"
    }
  </script>
  
  <style scoped>
  
  </style>